<digires-google-map  [markers]="markers"
                      [zoom]="zoom"
                      [center]="center"
                      (mapClicked)="onMapClicked($event)"
></digires-google-map>
